import './tableStyles.scss';

import { createClassName } from 'utils/createClassName';

export const createTableElementClassName = createClassName('table');
